import React, { useState } from "react";
import Modal from "../Modal/Modal";
import { useClinicData } from "../../context/ClinicDataContext";
import { formatRM } from "../../utils/format";

const METHODS = ["Cash", "Card", "DuitNow QR", "Bank transfer", "Insurance / panel"];

const RecordPaymentModal = ({ invoice, onClose }) => {
  const { invoiceTotal, recordPayment, patientById } = useClinicData();
  const outstanding = invoiceTotal(invoice) - invoice.paid;
  const [amount, setAmount] = useState(outstanding.toFixed(2));
  const [method, setMethod] = useState("Cash");
  const [error, setError] = useState("");

  const handleSave = () => {
    const value = Number(amount);
    if (!value || value <= 0) {
      setError("Enter an amount greater than RM 0.");
      return;
    }
    if (value > outstanding + 0.001) {
      setError(`The amount can't be more than the outstanding ${formatRM(outstanding)}.`);
      return;
    }
    recordPayment(invoice.id, value, method);
    onClose();
  };

  return (
    <Modal
      title={`Record payment for ${invoice.id}`}
      onClose={onClose}
      width={460}
      footer={
        <>
          <button className="btn btn--secondary" type="button" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn--primary" type="button" onClick={handleSave}>
            Record payment
          </button>
        </>
      }
    >
      <p className="modal__lead">
        {patientById[invoice.patientId]?.name} owes <strong>{formatRM(outstanding)}</strong>.
      </p>
      <div className="form-grid">
        <label className="form-field">
          <span className="form-field__label">Amount (RM)</span>
          <input
            className="form-field__control"
            type="number"
            min="0"
            step="0.01"
            inputMode="decimal"
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value);
              setError("");
            }}
          />
        </label>
        <label className="form-field">
          <span className="form-field__label">Payment method</span>
          <select className="form-field__control" value={method} onChange={(e) => setMethod(e.target.value)}>
            {METHODS.map((m) => (
              <option key={m}>{m}</option>
            ))}
          </select>
        </label>
      </div>
      {error && (
        <p className="form-error" role="alert">
          {error}
        </p>
      )}
    </Modal>
  );
};

export default RecordPaymentModal;
